// Unified recent-sessions reader: pulls from both the draft session store
// and the contest session store, sorts by most recently saved.
const DRAFT_KEY = "pbo-session-v1";
const CONTEST_KEY = "pbo-contest-session-v1";

const readJson = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || {};
  } catch {
    return {};
  }
};

export const getRecentSessions = (limit = 8) => {
  const drafts = readJson(DRAFT_KEY);
  const contests = readJson(CONTEST_KEY);
  const all = [];
  for (const [code, v] of Object.entries(drafts)) {
    all.push({
      code,
      kind: "draft",
      participantId: v.participantId,
      username: v.username,
      savedAt: v.savedAt || 0,
    });
  }
  for (const [code, v] of Object.entries(contests)) {
    all.push({
      code,
      kind: "contest",
      participantId: v.participantId,
      username: v.username,
      savedAt: v.savedAt || 0,
    });
  }
  all.sort((a, b) => b.savedAt - a.savedAt);
  return all.slice(0, limit);
};

export const removeRecentSession = (code, kind) => {
  const key = kind === "contest" ? CONTEST_KEY : DRAFT_KEY;
  const data = readJson(key);
  delete data[code.toUpperCase()];
  localStorage.setItem(key, JSON.stringify(data));
};
